// frontend/dashboard/src/router/modules/authRoutes.js
// Responsible for: auth route definitions — /login
// English: Public routes that do NOT require authentication.
// Thai: routes สาธารณะที่ไม่ต้องการ authentication

import { debugLog } from '../../utils/debugGate.js';

const ROUTE_DEBUG_NAMESPACE = '[router/authRoutes]';

const PAGE_REGISTRY = {
  LoginPage:           () => import('../../pages/LoginPage.vue'),
  ForgotPasswordPage:  () => import('../../pages/ForgotPasswordPage.vue'),
  ResetPasswordPage:   () => import('../../pages/ResetPasswordPage.vue'),
  // English: AcceptInvitePage — public page for staff invite acceptance. Invitee sets password, account is created.
  // ไทย: AcceptInvitePage — หน้าสาธารณะสำหรับรับ invite staff ผู้รับตั้ง password แล้วระบบสร้าง account ให้
  AcceptInvitePage:    () => import('../../pages/AcceptInvitePage.vue'),
};

function buildLazyPage(registryKey, debugLabel) {
  return async () => {
    const loader = PAGE_REGISTRY[registryKey];

    if (!loader) {
      throw new Error(`${ROUTE_DEBUG_NAMESPACE} No registry entry for key: ${registryKey}`);
    }

    try {
      const module = await loader();

      // [Debug output disabled — freeze/performance isolation | ปิด debug output ชั่วคราวเพื่อแยกปัญหา freeze/performance]
      // debugLog(`${ROUTE_DEBUG_NAMESPACE} [LAZY_IMPORT_SUCCESS]`, {
      //   registryKey,
      //   debugLabel,
      // });

      return module;
    } catch (error) {
      console.error(`${ROUTE_DEBUG_NAMESPACE} [LAZY_IMPORT_ERROR]`, {
        registryKey,
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  };
}

const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: buildLazyPage('LoginPage', 'LoginPage'),
    meta: {
      section:      'auth',
      requiresAuth: false,
      guestOnly:    true,
      layout:       'blank',
      title:        'Sign In',
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: buildLazyPage('ForgotPasswordPage', 'ForgotPasswordPage'),
    meta: {
      section:      'auth',
      requiresAuth: false,
      layout:       'blank',
      title:        'Forgot Password',
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: buildLazyPage('ResetPasswordPage', 'ResetPasswordPage'),
    meta: {
      section:      'auth',
      requiresAuth: false,
      layout:       'blank',
      title:        'Reset Password',
    },
  },
  {
    path: '/accept-invite',
    name: 'AcceptInvite',
    component: buildLazyPage('AcceptInvitePage', 'AcceptInvitePage'),
    meta: {
      section:      'auth',
      requiresAuth: false,
      layout:       'blank',
      title:        'Accept Invitation',
    },
  },
];

// [Debug output disabled — freeze/performance isolation | ปิด debug output ชั่วคราวเพื่อแยกปัญหา freeze/performance]
// debugLog(`${ROUTE_DEBUG_NAMESPACE} [ROUTES_REGISTERED]`, {
//   routeCount: authRoutes.length,
//   routeNames: authRoutes.map((r) => r.name),
// });

export default authRoutes;
